"use client";

import {
  Select,
  SelectValue,
  SelectItem,
  SelectContent,
  SelectTrigger,
  type MapTile,
} from "@oreme/ui";
import { useTranslations } from "next-intl";
import React, { type ReactElement, useEffect } from "react";
import { useMapLibre } from "@/hooks";
import { mapTiles } from "@/utils";

function SitesMapSwitchTile(): ReactElement {
  const t = useTranslations("sites.MapSwitchTile");
  const { map, tile, setTile, init } = useMapLibre();

  useEffect(() => {
    if (map) {
      map.on("style.load", () => {
        init(map);
      });
    }
  }, [map, init]);

  const handleChange = (value: string): void => {
    const newTile = mapTiles.get(value) as MapTile;
    setTile(newTile);
  };

  return (
    <Select defaultValue={tile.id} onValueChange={handleChange}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder={tile.title} />
      </SelectTrigger>
      <SelectContent>
        {Array.from(mapTiles).map(([key, tile]): ReactElement => {
          return (
            <SelectItem key={key} value={tile.id}>
              {t(tile.id)}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}

export { SitesMapSwitchTile };
